import React from "react";
import AnimateLines from "@/components/AnimateLine";
import AdaptiveImage from "@/components/AdaptiveImage";
import EthImage from "@/components/EthImage";
import ImageItem from "@/components/ImageItem";

import { AnimateProps } from "../../../types";
import { fomatDecimal } from "@/utils";

import "./index.css";

const Part5: React.FC<AnimateProps> = (props) => {
  const { data } = props;
  return (
    <div className="part_contain part_contain_5">
      <div style={{ flex: 1, width: "100%" }} />
      <div className="part_content">
        <AnimateLines animateType={props.type}>
          <p className="text_title mb_16">Paper Hand</p>
          <div className="row_center mb_30">
            <ImageItem url={data.paper_hand.image_url} />
            <p className="text_remind_num">{data.paper_hand.name || data.paper_hand.collection_name + ' #' + data.paper_hand.token_id}</p>
          </div>
          <p className="mb_10">
            <span className="text_content">Sold price</span>&ensp;
            <span className="text_num">{fomatDecimal(data.paper_hand.sell_cost)}</span>
            <EthImage />
          </p>
          <p className="mb_20">
            <span className="text_content">Less profits</span>&ensp;
            <span className="text_num">{fomatDecimal(data.paper_hand.floor_price - data.paper_hand.sell_cost)}</span>
            <EthImage />
          </p>
          <p>
            <span className="text_content">Hope you still hold now!</span>
          </p>
        </AnimateLines>
      </div>
      <div style={{ flex: 1, width: "100%" }} />
      <AnimateLines animateType={props.type} animateName="animate__fadeIn">
        <div>
          <AdaptiveImage name="Frame101026" />
        </div>
      </AnimateLines>
      <div style={{ flex: 2, width: "100%" }} />
    </div>
  );
};

export default Part5;
